import styled from "@emotion/styled";

export const GridContainer = styled.div`
  height: 100%;

  display: flex;
  flex-direction: column;

  background: white;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.05);
  border-radius: 20px;

  overflow-x: auto;
  overflow-y: visible;

  user-select: none;
`;
